import { useEffect, useRef } from 'react';
import { useAppSelector } from './reduxHooks';

export const useThemeWatcher = (): void => {
  const { theme, mode, interfaceStyle } = useAppSelector(
    (state) => state.theme
  );
  const root = useRef(document.documentElement);

  useEffect(() => {
    const html = root.current;
    if (html) {
      html.setAttribute('data-no-transition', '');
      html.setAttribute('data-theme', theme);
      html.setAttribute('data-theme-mode', mode);
      html.setAttribute('data-interface-style', interfaceStyle);
      html.classList.remove('light', 'dark');
      html.classList.add(theme);
      html.style.colorScheme = theme;
      localStorage.setItem('vite-ui-theme', theme);
      requestAnimationFrame(() => {
        html.removeAttribute('data-no-transition');
      });
    }
  }, [interfaceStyle, mode, theme]);
};
